import React, { useState, useEffect } from "react";
import Ratings from "./Ratings";
import RatingTemp from "./RatingTemp";
import Pagination from "./Pagination";
import { AiFillStar } from "react-icons/ai";
import RatingReact from "react-rating";
import { CiStar } from "react-icons/ci";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  customer_review,
  messageClear,
  get_reviews,
  get_product,
} from "../store/reducers/homeReducer";
import toast from "react-hot-toast";
import { BookOpen, Star } from "lucide-react";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";

const Reviews = ({ product }) => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { successMessage, reviews, totalReview, rating_review } = useSelector(
    (state) => state.home
  );
  const [pageNumber, setPageNumber] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const [rat, setRat] = useState("");
  const [re, setRe] = useState("");

  const review_submit = (e) => {
    e.preventDefault();
    const obj = {
      name: userInfo.name,
      review: re,
      rating: rat,
      productId: product._id,
    };
    dispatch(customer_review(obj));
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(
        get_reviews({
          productId: product._id,
          pageNumber,
        })
      );
      dispatch(get_product(product.slug));
      setRat("");
      setRe("");
      dispatch(messageClear());
    }
  }, [successMessage]);

  useEffect(() => {
    if (product._id) {
      dispatch(
        get_reviews({
          productId: product._id,
          pageNumber,
        })
      );
    }
  }, [pageNumber, product]);

  return (
    <div className="mt-8">
      <div className="flex gap-10 md:flex-col">
        <div className="flex flex-col gap-2 justify-start items-start py-4">
          <div>
            <span className="text-6xl font-semibold">{product.rating}</span>
            <span className="text-3xl font-semibold text-gray-900">/5</span>
          </div>
          <div className="flex text-4xl">
            <Ratings ratings={product.rating} />
          </div>
          <p className="text-sm text-gray-600">{totalReview} Reviews</p>
        </div>
        <div className="flex gap-2 flex-col py-4">
          <div className="flex justify-start items-center gap-5">
            <div className="text-md flex gap-1 w-[93px]">
              <RatingTemp rating={5} />
            </div>
            <div className="overflow-hidden rounded-full w-[200px] h-[10px] bg-gray-200 relative">
              <div
                style={{
                  width: `${Math.floor(
                    (100 * (rating_review[0]?.sum || 0)) / totalReview
                  )}%`,
                }}
                className="rounded-full h-full bg-[#EDBB0E] "
              ></div>
            </div>
            <p className="text-sm text-gray-600 w-[0%]">{rating_review[0]?.sum}</p>
          </div>
          <div className="flex justify-start items-center gap-5">
            <div className="text-md flex gap-1 w-[93px]">
              <RatingTemp rating={4} />
            </div>
            <div className="overflow-hidden rounded-full w-[200px] h-[10px] bg-gray-200 relative">
              <div
                style={{
                  width: `${Math.floor(
                    (100 * (rating_review[1]?.sum || 0)) / totalReview
                  )}%`,
                }}
                className="rounded-full h-full bg-[#EDBB0E]"
              ></div>
            </div>
            <p className="text-sm text-gray-600 w-[0%]">{rating_review[1]?.sum}</p>
          </div>
          <div className="flex justify-start items-center gap-5">
            <div className="text-md flex gap-1 w-[93px]">
              <RatingTemp rating={3} />
            </div>
            <div className="overflow-hidden rounded-full w-[200px] h-[10px] bg-gray-200 relative">
              <div
                style={{
                  width: `${Math.floor(
                    (100 * (rating_review[2]?.sum || 0)) / totalReview
                  )}%`,
                }}
                className="rounded-full h-full bg-[#EDBB0E]"
              ></div>
            </div>
            <p className="text-sm text-gray-600 w-[0%]">{rating_review[2]?.sum}</p>
          </div>
          <div className="flex justify-start items-center gap-5">
            <div className="text-md flex gap-1 w-[93px]">
              <RatingTemp rating={2} />
            </div>
            <div className="overflow-hidden rounded-full w-[200px] h-[10px] bg-gray-200 relative">
              <div
                style={{
                  width: `${Math.floor(
                    (100 * (rating_review[3]?.sum || 0)) / totalReview
                  )}%`,
                }}
                className="rounded-full h-full bg-[#EDBB0E]"
              ></div>
            </div>
            <p className="text-sm text-gray-600 w-[0%]">{rating_review[3]?.sum}</p>
          </div>
          <div className="flex justify-start items-center gap-5">
            <div className="text-md flex gap-1 w-[93px]">
              <RatingTemp rating={1} />
            </div>
            <div className="overflow-hidden rounded-full w-[200px] h-[10px] bg-gray-200 relative">
              <div
                style={{
                  width: `${Math.floor(
                    (100 * (rating_review[4]?.sum || 0)) / totalReview
                  )}%`,
                }}
                className="rounded-full h-full bg-[#EDBB0E]"
              ></div>
            </div>
            <p className="text-sm text-gray-600 w-[0%]">{rating_review[4]?.sum}</p>
          </div>
        </div>
      </div>
      <h2 className="text-gray-900 text-xl font-bold py-5">
        Product reviews {totalReview}
      </h2>
      <div className="flex flex-col gap-8 pb-10 pt-4">
        {reviews.map((r, i) => (
          <div key={i} className="flex flex-col gap-1">
            <div className="flex items-center justify-between mb-4">
              <div className="flex gap-1 text-xl">
                <RatingTemp rating={r.rating} />
              </div>
              <span className="text-gray-400 text-xs font-bold ml-5">
                {r.date}
              </span>
            </div>
            <span className="text-gray-900 text-md">{r.name}</span>
            <p className="text-gray-400 font-bold text-sm">{r.review}</p>
          </div>
        ))}
        <div className="flex justify-end">
          {totalReview > 5 && (
            <Pagination
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              totalItem={totalReview}
              perPage={perPage}
              showItem={Math.round(totalReview / 5)}
            />
          )}
        </div>
      </div>
      <h1 className="text-gray-900 mb-5 text-[18px] font-bold flex items-center">
        <BookOpen className="mr-2"/> Your review
      </h1>
      <div>
        {userInfo ? (
          <div className="flex flex-col">
            <div className="flex">
            <RatingReact
            
            onChange={(e) => setRat(e)}
            initialRating={rat}
            emptySymbol={
              <span
                className="text-gray-400 text-4xl"
                style={{ marginRight: "2rem" }}
              >
                <Star />
              </span>
            }
            fullSymbol={
              <span
                className="text-[#EDBB0E] text-4xl"
                style={{ marginRight: "2rem" }}
              >
                <Star />
              </span>
            }
          />
            </div>

            <form onSubmit={review_submit}>
              <Label className='text-md'>Leave an honest, and respecful review. Your reviews are public and seen by everyone that views this page.</Label>
              <Textarea
                value={re}
                required
                onChange={(e) => setRe(e.target.value)}
                className="w-full p-5 mt-2"
                rows={5}
                placeholder="Write your review here..."
              />
              <div className="mt-2">
                <Button className="py-1 sm:w-full sm:mb-5">Submit my review</Button>
              </div>
            </form>
          </div>
        ) : (
          <div>
            <Link to="/login">
              <Button>Login</Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Reviews;
